import { render, staticRenderFns } from "./NewAddress.vue?vue&type=template&id=746e9e31&scoped=true&"
import script from "./NewAddress.vue?vue&type=script&lang=ts&"
export * from "./NewAddress.vue?vue&type=script&lang=ts&"
import style0 from "./NewAddress.vue?vue&type=style&index=0&id=746e9e31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746e9e31",
  null
  
)

export default component.exports